import React from 'react';
import PropTypes from 'prop-types';
import { ModalShell } from '../modalsShared';

const ViewRequestModal = ({ isOpen, request, onClose }) => {
  if (!isOpen) return null;

  const details = [
    { label: 'SCRN', value: request?.scrn || '-' },
    { label: 'Requested by', value: request?.requestedBy?.name || '-' },
    { label: 'Requested date', value: request?.requestedDate || '-' },
    { label: 'Project', value: request?.project?.name || '-' },
    { label: 'Old status', value: request?.oldStatus || '-' },
    { label: 'New status', value: request?.newStatus || '-' },
    { label: 'Effective date', value: request?.effectiveDate || '-' },
    { label: 'Reason', value: request?.reason || '-' },
    { label: 'Approver', value: request?.approver?.name || '-' },
    { label: 'Request status', value: request?.requestStatus || 'Open' },
    { label: 'Approve remarks', value: request?.approveRemarks || '-' },
  ];

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      title="Request details"
      size="medium"
      modalClassName="request-history-submodal"
    >
      <div className="request-history-details">
        {details.map((item) => (
          <div key={item.label} className="request-history-detail-row">
            <span className="request-history-detail-label">{item.label}</span>
            <span className="request-history-detail-value">{item.value}</span>
          </div>
        ))}
      </div>

      <div className="modal-actions">
        <button type="button" className="btn-cancel" onClick={onClose}>
          Close
        </button>
      </div>
    </ModalShell>
  );
};

ViewRequestModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  request: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

export default ViewRequestModal;
